import React from 'react';
import { SortConfig } from '../hooks/useSortableTable';
import Icon from '../components/Icon';

interface SortableHeaderProps {
  label: string;
  sortKey: string;
  sortConfig: SortConfig;
  onSort: (key: string) => void;
  className?: string;
  style?: React.CSSProperties;
}

const SortableHeader: React.FC<SortableHeaderProps> = ({
  label,
  sortKey,
  sortConfig,
  onSort,
  className = '',
  style
}) => {
  const isActive = sortConfig.field === sortKey;
  const direction = sortConfig.direction;

  const getSortIcon = () => {
    if (!isActive || !direction) return 'chevronUp';
    return direction === 'asc' ? 'chevronUp' : 'chevronDown';
  };

  const getSortClass = () => {
    if (!isActive) return 'sort-inactive';
    return direction === 'asc' ? 'sort-asc' : 'sort-desc';
  };

  return (
    <th
      className={`sortable-header ${className}`}
      onClick={() => onSort(sortKey)}
      style={style}
    >
      <div className="header-content">
        {label}
        <span className={`sort-indicator ${getSortClass()}`}>
          <Icon name={getSortIcon()} size={14} />
        </span>
      </div>
    </th>
  );
};

export default SortableHeader;
